import HazardousWaste from '../components/HazardousWaste';

function HazardousWastePage() {
  return <HazardousWaste />;
}

export default HazardousWastePage;
